export default "https://cdn-static.gokick.com/assets/f56d8541e187cf36c438a68224daa166420c5eb6/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";